export default __webpack_public_path__ + "static/media/form-vector-2.f7991c6c.png";